module.exports = "https://coursera_assets.s3.amazonaws.com/images/8d71e6c4911494d1f51a8433d967ffa2.png";